import { render, staticRenderFns } from "./PropecInfoVideoBlockLayout.vue?vue&type=template&id=2451a83a"
import script from "./PropecInfoVideoBlockLayout.vue?vue&type=script&lang=js"
export * from "./PropecInfoVideoBlockLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports